import { render, staticRenderFns } from "./runup.vue?vue&type=template&id=a11755a8&"
import script from "./runup.vue?vue&type=script&lang=js&"
export * from "./runup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports